<template>
  <div id="app">
      <router-view/>
  </div>
</template>

<script>
    import store from "./store";

    export default {
        name: 'app',
        mounted() {
            if(document.body.clientWidth<800){
                this.$router.push('./onlyPC')
            }
        }
  }
</script>
<style>
* {
  padding: 0;
  margin: 0;
  border: 0;
  box-sizing: border-box;
  /*overflow: hidden;*/
  /*white-space: nowrap;*/
}
body, html {
  height: 100%;
  font-family: 'PingFang SC','Microsoft YaHei','Helvetica Neue',Helvetica,STHeitiSC-Light,Arial,sans-serif;
  /*font-size: 12px;*/
  overflow: hidden;
}
body {
  font-size: 0.7vw;
  overflow: hidden;
}
a {
    text-decoration: none;
}
ul li {
    list-style: none;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  height: 100%;
}
.public {
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.public-right {
  height: 50px;
  /*width: 93%;*/
  width: calc(100% - 1.4rem);
  background: #ffffff;
  border-bottom: 1px solid #e3e3e3;
}
.right-content {
    width: 93%;
    width: calc(100% - 1.4rem);
    position: absolute;
    top: 50px;
    left: 1.4rem;
    height: calc(100% - 50px);
    overflow: auto;
}
.right-content .el-tabs__content {
    height: calc(100% - 39px);
    /*padding-top: 0;*/
    padding-bottom: 0;
}
.right-content .el-tabs--border-card > .el-tabs__content {
    padding-left: 0;
}
.house-right .room-info .el-tabs--border-card > .el-tabs__header{
    border-bottom: 1px solid #999;
    height: 0.39rem;
}
.el-message-box__content{
    padding-bottom: 0;
}
.el-date-editor .el-range-separator {
    padding: 0 !important;
}

.totle-content{
    margin-bottom:0.2rem;
    margin-right: 0.15rem;
}
.table-content {
    margin-right: 0.15rem;
}

.select-search {
    margin: 0 0.15rem 0.2rem 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.select-group {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
}

.select-group .el-select {
    margin-right: 5%;
}

.button-group {
    display: flex;
    /*flex-direction: row-reverse;*/
}

.button-group .el-button {
    margin-left: 5%;
}
.pagination-part{
    margin-top:0.15rem;
}
.el-popup-parent--hidden {
    padding-right: 0 !important;
}
.el-dialog__body {
    /*height: 50vh;*/
    overflow: auto;
    padding-bottom: 10px;
}
/*.el-dialog {*/
    /*width: 40% !important;*/
/*}*/
.el-table__body-wrapper {
    overflow-y: visible !important;
}
.operate-records-dialog .el-dialog__body, .checkin-records .el-dialog__body {
    height: 50vh;
    overflow-x: auto;
}
.el-loading-mask {
    z-index: 3000 !important;
}
.el-tree-node__label {
    font-size: 0.7vw !important;
}
.el-input--prefix .el-input__inner {
    padding-left: 2.4vw;
}

.el-table__body-wrapper {
    max-height:68vh;
    overflow-y: auto;
}

.login-all-body .el-form-item__label{
    padding:0 !important;
}

.power-records .el-table {
    max-height: 55vh !important;
}

::-webkit-scrollbar {/*滚动条整体样式*/
    width: 7px;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 7px;
}
::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(152, 152, 152, 0.2);
    background: #e3e3e3;
}
::-webkit-scrollbar-track {/*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(238, 238, 238, 0.51);
    border-radius: 10px;
    background: rgb(243, 243, 243);
}

.instruction-dialog .el-dialog__body{
    height:60vh;
    padding: 0px 20px;
}
</style>
